export default {
  //таблица соответствий тайтлов и языков
  //формат инсталляция -> язык. если не найдено то юзается default (логика в helpers/i18n/missing и /helpers/metaMixin и router/index.js (поле customMeta))
  Titles: {
    ru: {
      ru: process.env.VUE_APP_INSTALL_NAME,
      //для каждого языка можно прописать отдельно. но сделал default механизм для упрощения (helpers/i18n/missing)
      default: "Third Opinion",
    },
    en: {
      //для остальных инсталяций все остается как было. если нужно можно здесь определить название AI Opinion для испанского. вот так:
      //es: "Испанский перевод AI Opinion. Подтянется в тайтлы"
      en: process.env.VUE_APP_INSTALL_NAME,
      default: process.env.VUE_APP_INSTALL_NAME,
    },
    kz: {
      ru: process.env.VUE_APP_INSTALL_NAME,
      default: process.env.VUE_APP_INSTALL_NAME,
    },
  },
};
